import { connect } from 'react-redux'
import SlidesScreenCreator from './SlidesScreenCreator'
import selectSlideDeck from '../../dataStore/selectors/selectSlideDeck'
import selectSlideDeckURL from '../../dataStore/selectors/selectSlideDeckURL'
import { openSlidesMediaDrawer } from '../../dataStore/actions/ui/uiActions'
import slidesActions from '../../dataStore/actions/slides'
import { setAutoSpotlight, setMediaType } from '../../dataStore/actions/room/room'
import { mediaType as MediaType } from '@bt-react/constants'
import notifications from '../../dataStore/actions/notifications'

const mapStateToProps = (state, props) => {

  return {
    ...props,
    presentationURL: selectSlideDeckURL(state),
    selectedSlide: state.slides.selectedSlide,
    selectedSlideStep: state.slides.selectedSlideStep,
    isBridge: !!state.config.bridgeName,
    slideDeck: selectSlideDeck(state),
    BTID: state.user.BTID,
    slidesDeckVersion: state.slides.apiVersion,
    presenterLayoutsActive: state.layouts.presenterLayout.presenterLayoutsActive
  }
}

const mapDispatchToProps = (dispatch) => ({
  onJumpToSlidesClick: () => dispatch(openSlidesMediaDrawer()),
  onEndClick: (layoutsActive: boolean) => {
    if (layoutsActive) {
      dispatch(setAutoSpotlight(true))
      dispatch(dispatch(setMediaType(MediaType.SPOTLIGHT)))
    }
    dispatch(slidesActions.stopSlides())
  },
  onPreviousClick: (presentation) => dispatch(slidesActions.previous(presentation)),
  onNextClick: (presentation) => dispatch(slidesActions.next(presentation)),
  navigate: (slide, step) => dispatch(slidesActions.navigate(slide, step)),
  onVideoError: () => dispatch(notifications.addNotification('Video is not supported in slides', 4000))
})

export default connect(mapStateToProps, mapDispatchToProps)(SlidesScreenCreator)
